var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmakologiya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45.778,
    height: 45.778,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5.6 5.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil3{fill:#453d83;fill-rule:nonzero}.fil4,.fil5,.fil8{fill:#51489a;fill-rule:nonzero}.fil5,.fil8{fill:#5f55af}.fil8{fill:#e9f3fe}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2792289626208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 2.8c0 1.55-1.25 2.8-2.8 2.8C1.25 5.6 0 4.35 0 2.8 0 1.25 1.25 0 2.8 0c1.55 0 2.8 1.25 2.8 2.8z",
    style: {
      fill: "#76b6fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03 2.64c0 1.1-.89 1.99-1.99 1.99s-1.99-.89-1.99-1.99S1.94.65 3.04.65s1.99.89 1.99 1.99z",
    style: {
      fill: "#86befb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05.91a.053.053 0 0 1 .01-.08c.02-.02.06-.02.08.01l1.2 1.42c.02.02.02.06-.01.08-.01.01-.02.01-.04.01s-.03-.01-.04-.02L1.05.91zM2.8.49c-.03 0-.05.02-.05.05v1.31c0 .03.02.05.05.05.03 0 .05-.02.05-.05V.54c0-.03-.02-.05-.05-.05zm.78 1.74c.01.01.02.01.03.01.02 0 .03-.01.04-.02l.77-.98c.02-.02.01-.06-.01-.08-.02-.02-.06-.01-.08.01l-.77.98c-.02.02-.01.06.01.08zm1.78.51H3.61c-.03 0-.05.02-.05.05 0 .03.02.05.05.05h1.75c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05zm-2.15.82a.06.06 0 0 0-.08 0 .06.06 0 0 0 0 .08l1.09 1.09c.01.01.02.02.04.02.01 0 .03-.01.04-.02a.06.06 0 0 0 0-.08L3.21 3.56zm-.78.1c-.03-.01-.06-.01-.07.02l-.55.98c-.01.03-.01.06.02.07.01 0 .02.01.03.01.02 0 .04-.01.05-.03l.55-.98c.01-.03.01-.06-.02-.07zm-.31-.42c-.02-.02-.05-.03-.08-.01L.73 4.32c-.02.02-.03.05-.01.08.01.01.03.02.04.02.01 0 .02 0 .03-.01L2.1 3.32c.02-.02.03-.05.01-.08zM.77 2.85h1.2c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05H.77c-.03 0-.05.02-.05.05 0 .03.02.05.05.05z",
    style: {
      fill: "#1380e2",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02.55c0 .12-.1.22-.22.22s-.22-.1-.22-.22.1-.22.22-.22.22.1.22.22zM1.18 4.42a.37.37 0 1 1-.74 0 .37.37 0 1 1 .74 0zM5.6 2.8a.37.37 0 1 1-.74 0 .37.37 0 1 1 .74 0z",
    className: "fil3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59 1.2c0 .12-.1.22-.22.22s-.22-.1-.22-.22.1-.22.22-.22.22.1.22.22zM2.08 4.7c0 .12-.1.22-.22.22s-.22-.1-.22-.22.1-.22.22-.22.22.1.22.22zM.99 2.8c0 .12-.1.22-.22.22s-.22-.1-.22-.22.1-.22.22-.22.22.1.22.22zM1.51.83a.37.37 0 1 1-.74 0 .37.37 0 1 1 .74 0zm3.3 3.92a.49.49 0 1 1-.982-.002.49.49 0 0 1 .982.002z",
    className: "fil4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24 5.17c0 .08-.06.14-.14.14-.08 0-.14-.06-.14-.14 0-.08.06-.14.14-.14.08 0 .14.06.14.14zm-.87-3.5c0 .08-.06.14-.14.14-.08 0-.14-.06-.14-.14 0-.08.06-.14.14-.14.08 0 .14.06.14.14zm3.88-.49c0 .08-.06.14-.14.14-.08 0-.14-.06-.14-.14 0-.08.06-.14.14-.14.08 0 .14.06.14.14z",
    className: "fil3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07 2.8c0 .7-.57 1.27-1.27 1.27-.7 0-1.27-.57-1.27-1.27 0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27z",
    className: "fil5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82 3.54c-.23.32-.6.52-1.03.52a1.272 1.272 0 0 1-.75-2.3c-.15.21-.24.47-.24.75 0 .7.57 1.27 1.27 1.27.28 0 .54-.09.75-.24z",
    className: "fil4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51.83c0 .04-.01.09-.02.13-.04.01-.08.02-.13.02A.37.37 0 0 1 .99.61c0-.04.01-.09.02-.13.04-.01.08-.02.13-.02.21 0 .37.17.37.37zm2.86.15c-.03 0-.05 0-.07.01-.01.02-.01.05-.01.07 0 .12.1.22.22.22.03 0 .05 0 .07-.01.01-.02.01-.05.01-.07 0-.12-.1-.22-.22-.22zM2.07 4.7c0 .03 0 .05-.01.07-.02.01-.05.01-.07.01-.12 0-.22-.1-.22-.22 0-.03 0-.05.01-.07.02-.01.05-.01.07-.01.12 0 .22.1.22.22zM.98 2.8c0 .03 0 .05-.01.07-.02.01-.05.01-.07.01-.12 0-.22-.1-.22-.22 0-.03 0-.05.01-.07.02-.01.05-.01.07-.01.12 0 .22.1.22.22zm3.83 1.96c0 .06-.01.12-.03.17a.49.49 0 0 1-.63-.63.49.49 0 0 1 .66.46z",
    className: "fil5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8.33c-.03 0-.05 0-.07.01-.01.02-.01.05-.01.07 0 .12.1.22.22.22.03 0 .05 0 .07-.01.01-.02.01-.05.01-.07 0-.12-.1-.22-.22-.22zM1.18 4.42c0 .04-.01.09-.02.13-.04.01-.08.02-.13.02a.37.37 0 0 1-.37-.37c0-.04.01-.09.02-.13.04-.01.08-.02.13-.02.21 0 .37.17.37.37zm4.04-1.99c-.04 0-.09.01-.13.02-.01.04-.02.08-.02.13 0 .21.17.37.37.37.04 0 .09-.01.13-.02.01-.04.02-.08.02-.13a.37.37 0 0 0-.37-.37z",
    className: "fil4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.3 3.3a.38.38 0 0 1 0-.54l.34-.34a.38.38 0 0 1 .54 0c.15.15.15.39 0 .54l-.34.34a.38.38 0 0 1-.54 0z",
    style: {
      fill: "#e9cc5a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44 2.91c-.12.12-.15.31-.06.46a.38.38 0 0 1-.08-.6l.33-.33.03.03.12.12-.32.32z",
    style: {
      fill: "#eac23f",
      fillRule: "nonzero"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m3.3 2.84-.19.19-.54-.54.19-.19a.38.38 0 0 1 .54 0c.15.15.15.39 0 .54z",
    className: "fil8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.36 2.38a.395.395 0 0 0-.46.06l-.19.19-.15-.15.19-.19a.38.38 0 0 1 .54 0c.03.03.05.05.06.08z",
    style: {
      fill: "#c8e2fd",
      fillRule: "nonzero"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06 4.43c0 .03-.02.05-.05.05h-.55c-.03 0-.05-.02-.05-.05 0-.03.02-.05.05-.05h.55c.03 0 .05.02.05.05zm-.44.38h-.16c-.03 0-.05.02-.05.05 0 .03.02.05.05.05h.16c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05zm.27-.22h-.44c-.03 0-.05.02-.05.05 0 .03.02.05.05.05h.44c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05zM3.38.65h-.16c-.03 0-.05.02-.05.05 0 .03.02.05.05.05h.16c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05zm.27-.22h-.44c-.03 0-.05.02-.05.05 0 .03.02.05.05.05h.44c.03 0 .05-.02.05-.05 0-.03-.02-.05-.05-.05z",
    className: "fil8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmakologiya);
export default __webpack_public_path__ + "static/media/farmakologiya.b2963d7d30072d513040fbef4672897d.svg";
export { ForwardRef as ReactComponent };